<div class="time-picker-container dropdown">
    <button class="btn btn-default" type="button" id="dropdownMenuButton" data-toggle="dropdown" [disabled]="readonly"
        [ngClass]="{'ng-invalid ng-touched' : invalid}">
        <span class="ic-clock mt-1 mr-3" aria-hidden="true"></span>
        <span class="time-text">{{getHourIn12Format() | number: '2.0-0'}} : {{getMinutes() | number: '2.0-0'}}
            {{getAmPm()}}</span>

    </button>

    <div class="dropdown-menu time-edit-container" aria-labelledby="dropdownMenuButton" [style.width.px]="pickerWidth"
        (click)="menuClicked($event)">
        <div class="input-group">
            <span class="input-group-btn">
                <button class="btn btn-default" type="menu" (click)="onHourDown()"
                    [disabled]="!canDecrement || readonly" [ngClass]="{'is-disabled': readonly}">-</button>
            </span>
            <input type="text" class="form-control text-center" value="{{getHourIn12Format() | number: '2.0-0'}}"
                [ngClass]="{'is-disabled': readonly}" [disabled]="readonly" readonly>
            <span class="input-group-btn">
                <button class="btn btn-default" type="menu" (click)="onHourUp()" [disabled]="!canIncrement || readonly"
                    [ngClass]="{'is-disabled': readonly}">+</button>
            </span>
        </div>
        <div class="input-group mt-2">
            <span class="input-group-btn">
                <button class="btn" type="menu" (click)="onMinuteDown()"
                    [disabled]="!canDecrement || readonly">-</button>
            </span>
            <input type="text" class="form-control text-center" [leadZeroDateTime]="true"  [mask]="textMaskService.minutesMask"
                (change)="minutesManualChanged($event)" value="{{getMinutes()| number: '2.0-0'}}" [disabled]="readonly"
                [ngClass]="{'is-disabled': readonly}">
            <span class="input-group-btn">
                <button class="btn btn-default" type="menu" (click)="onMinuteUp()"
                    [disabled]="!canIncrement || readonly">+</button>
            </span>
        </div>

        <div class="input-group mt-2 ampm-btns">
            <span class="input-group-btn">
                <button class="btn btn-default" [ngClass]="{'selected': isAm()}" type="menu" (click)="onAm()"
                    [disabled]="readonly">AM</button>
            </span>
            <span class="input-group-btn">
                <button class="btn btn-default" [ngClass]="{'selected': isPm()}" type="menu" (click)="onPm()"
                    [disabled]="readonly">PM</button>
            </span>
        </div>
    </div>
</div>
